<template>
  <div class=" is-fullwidth">
    
    <div class="notification is-info" v-if="loading === true">Loading orders ...</div>

    <div class="notification is-warning" v-if="this.orders.length==0 && loading === false">There are no open orders using the Historical LW garment type</div>
    
    <div v-if="this.orders.length > 0 && loading === false">
      

            <div class="box">	
              <h4 class="title is-4">Open Orders Using Historical LW Garment Type ({{ this.orders.length }})</h4>
              
            
              <table class="table is-striped is-fullwidth is-hoverable" >
                <thead>
                  <tr>
                    <th>PO Number</th>
                    <th>Order Date</th>
                    <th>Design Name</th>
                    <th width="50">&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in this.orders" :key="row.id">
                    <td>{{ row.ponumber }}</td>
                    <td>{{ row.orderdate }}</td>
                    <td>{{ row.designname }}</td>
                    <td><a :href="ASP_URL + '/sales/order/viewdesign?designID=' + row.designID + '&clientID=' + row.orderClientID + '&returnUrl=' + APP_URL + '/production/hist-lw-orders'" ><button class="button is-small is-link" >Update</button></a></td>
                  </tr>
                </tbody>
              </table>

            </div>

    </div>

</div>
</template>

<script>


//import OrderService from '@/services/OrderService.js';
import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
       orders: [],
      showModal: false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      APP_URL : process.env.VUE_APP_URL,
      search: '',
      working: false,
      accessToken: '',
      
    }
  },
   methods: {
    
    
      async getHistLwOrders() {
        this.loading = true;
        UtilityService.getSimpleApiData(this.accessToken, "orders/open?garment_id=42&order_by=orderdate DESC").then(
               response => {
                this.orders = response 
                this.loading = false;
               }
            );
      },
      
  
    
  },
  computed : {
    
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getHistLwOrders();
          
        });
  },
 
  mounted() {
    
      
  },
  watch: {
    '$route'() {
      
    }
  }
}


</script>

